// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"208":"12a71fc5323be0aa","767":"d1d7cbafa5eaef4e"}[chunkId] + ".js";
};